// extracted by mini-css-extract-plugin
export var chip = "_qq-0";
export var icon = "_qq-1";
export var remove = "_qq-2";
export var removeIcon = "_qq-3";